import themeUtils from '../themeUtils';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this._flickity = this._flickity.bind(this);
    this.container = 'data-testimonials-container';
    this.slide = 'data-testimonial-item';

    this.$window = $(window);
    this.$testimonialsContainer = this.$el.find(`[${this.container}]`);
    this.flickity = null;

    this._flickity();
    this._bindEvents();
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    this.$window.off('resize.testimonials');
    this._destroyFlickity();
  }

  _bindEvents() {
    this.$window.on('resize.testimonials', themeUtils.debounce(this._flickity, 100));
  }

  _flickity() {
    if (!this.$testimonialsContainer.length) { return; }

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      this._destroyFlickity();
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.$testimonialsContainer[0], {
      cellAlign: 'center',
      cellSelector: `[${this.slide}]`,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  onBlockSelect(event) {
    if (!this.flickity) { return; }

    const index = parseInt($(event.target).attr(this.slide), 10) - 1;
    this.flickity.select(index, true);
  }
}
